import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Trash2 } from "react-feather";
import Footer from "../../components/Footer";
import api from "../../api/api";
import { getCurrentUser } from "../../utils/authService";
import useDetails from "../../hooks/useDetails";
import { GetStudentDetails } from "../../api/student";
import usePayments from "../../hooks/usePayments";
import StudentInfo from "../../components/StudentInfo";

import { InputText } from "primereact/inputtext";
import { FilterMatchMode } from "primereact/api";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Paginator } from "primereact/paginator";

const CourseMapping = () => {
  const { data } = useDetails();
  const paymentComplete = data?.payment_complete;
  const { payment } = usePayments();
  const [level, setLevel] = useState();
  const [courses, setCourses] = useState([]);
  const [selectedCourses, setSelectedCourses] = useState([]);
  const [mappedCourses, setMappedCourses] = useState([]);
  const [registeredCourses, setRegisteredCourses] = useState([]);
  const [registeredShow, setRegisteredShow] = useState(false);
  const [pagination, setPagination] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [validation, setValidation] = useState();
  const [rowClick, setRowClick] = useState(true);
  const [totalRecords, setTotalRecords] = useState();
  const [totalSelectedUnits, setTotalSelectedUnits] = useState(0);
  const [departments, setDepartments] = useState([]);
  const [department, setDepartment] = useState();
  const [programList, setProgramList] = useState();
  const [program, setProgram] = useState("");
  const [faculty, setFaculty] = useState([]);
  const [filteredCourses, setFilteredCourses] = useState([]);
  const [selectedFilteredCourses, setSelectedFilteredCourses] = useState();
  const [query, setQuery] = useState("");
  const [session, setSession] = useState("");
  const [affiliate, setAffiliate] = useState("");

  const theCourses = mappedCourses?.map((course) => course.course_id);

  const [grade, setGrade] = useState("");
  const [semester, setSemester] = useState();

  const [toggle, setToggle] = useState(false);

  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [courseCode, setCourseCode] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  const user = getCurrentUser();

  const token = user?.access;

  const totalUnits = selectedCourses.reduce(
    (acc, course) => acc + parseInt(course.unit),
    0
  );

  const totalRegisteredUnits = registeredCourses.reduce(
    (acc, course) => acc + parseInt(course.unit),
    0
  );

  const mapped = selectedCourses?.map((course) => {
    return { course_id: course.id };
  });

  const onPageChange = (event) => {
    console.log(event, "<<<<<<<");
    setPagination(event.page); // API pagination typically starts at 1
  };

  const onRowsChange = (event) => {
    setPagination(1); // Reset to the first page when changing page size
    setPageSize(event.value);
  };

  const getDetails = async () => {
    setLoading(true);
    try {
      const data = await GetStudentDetails(user);
      setLevel(data?.level);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getCourses = async () => {
    try {
      const { data } = await api.get(
        `/courses/all/?p=${
          pagination + 1
        }&page_size=${pageSize}&semester_int=${semester}&search_string=${courseCode}&affliate=${affiliate}`
      );
      setTotalRecords(data?.count);
      setCourses(data?.data);
    } catch (error) {}
  };

  const getFilteredCourses = async () => {
    try {
      const { data } = await api.get(
        `/courses/mapped/read?course_id_code=${query}`
      );
      // setFilteredCourses(data.data)
      setFilteredCourses(data.data.map((course) => course.course_id));
    } catch (error) {}
  };

  const getDepartments = async () => {
    try {
      const { data } = await api.get(`/department/all?page_size=${100}`);
      setDepartments(data?.results);
    } catch (error) {}
  };

  const getProgramLists = async () => {
    try {
      const { data } = await api.get(`/student/fetch-programme-of-study`);
      setProgramList(data.progrm_of_study);
    } catch (error) {}
  };

  const MAX_UNITS = 80;

  const handleSelectionChange = (e) => {
    // Calculate the total units of the selected courses
    const newSelectedCourses = e.value;
    let totalUnits = 0;
    newSelectedCourses.forEach((theCourses) => {
      totalUnits += parseInt(theCourses.unit); // Assuming quantity represents units
    });

    // Check if the total units exceed the allowed maximum
    if (totalUnits <= MAX_UNITS) {
      setSelectedCourses(newSelectedCourses);
      setTotalSelectedUnits(totalUnits);
    } else {
      alert(`Cannot exceed maximum of ${MAX_UNITS} units`);
    }
    // If the total units exceed the limit, don't update the selectedProducts state
  };

  function isObject(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
  }

  const handleCourseSelection = (event) => {
    if (isObject(event)) {
      const course = event;
      const newTotalUnits = totalUnits + parseInt(course.unit);

      // Check if adding the new course will exceed the maximum units
      if (newTotalUnits > MAX_UNITS) {
        alert(`Cannot exceed maximum of ${MAX_UNITS} units!`);
        return;
      }

      // Check if course is already in selectedCourses array
      if (
        selectedCourses.some(
          (selectedCourse) => selectedCourse.id === course.id
        )
      ) {
        alert("Course already selected!");
        return;
      }

      setSelectedCourses((prevSelectedCourses) => [
        ...prevSelectedCourses,
        course,
      ]);
      setQuery("");
    } else {
      const course = JSON.parse(event.target.value);
      const newTotalUnits = totalUnits + parseInt(course.unit);

      // Check if adding the new course will exceed the maximum units
      if (newTotalUnits > MAX_UNITS) {
        alert(`Cannot exceed maximum of ${MAX_UNITS} units!`);
        return;
      }

      // Check if course is already in selectedCourses array
      if (
        selectedCourses.some(
          (selectedCourse) => selectedCourse.id === course.id
        )
      ) {
        alert("Course already selected!");
        return;
      }

      setSelectedCourses((prevSelectedCourses) => [
        ...prevSelectedCourses,
        course,
      ]);
    }
  };

  const handleCourseDelete1 = (id) => {
    let newList = selectedCourses.filter((item) => item.id !== id);
    setSelectedCourses(newList);
  };

  const registerCourses = async (e) => {
    e.preventDefault();
    if (!level || !program || !semester || !affiliate)
      return toast.info("Please ensure you provide all mapping conditions");
    setLoading(true);
    try {
      const { data } = await api.post("/courses/map", {
        courses: mapped,
        mapped_program: program,
        mapped_level: Number(level),
        semester_int: Number(semester),
        affliate: affiliate,
      });
      setLoading(false);
      toast.success("Mapping Successful");
      setLevel("");
      setProgram("");
      setAffiliate("")
      setSemester("")
      setSelectedCourses([]);
    } catch (error) {
      setLoading(false);
      alert(error.response.data.message);
    }
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    console.log(_filters, "_filterrr");

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
    // if (value.length > 5) {
    setCourseCode(value);
    // }
  };

  const renderHeader = () => {
    return (
      <div className="flex justify-content-end">
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            placeholder="Keyword Search"
          />
        </span>
      </div>
    );
  };

  const header = renderHeader();

  useEffect(() => {
    getDetails();
    getDepartments();
    getProgramLists();
    // fetchPaymentStatus();
  }, []);

  useEffect(() => {
    getFilteredCourses();
  }, [query]);

  useEffect(() => {
    getCourses();
  }, [pagination, pageSize, courseCode, semester, affiliate]);

  const errorProp = {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  };

  const warnProp = {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  };

  const successProp = {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  };

  console.log(session);

  return (
    <div class="page-wrapper">
      {data && courses && (
        <div class="page-content-tab">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-12">
                <div class="page-title-box">
                  <div class="float-right">
                    <ol class="breadcrumb">
                      {/* <li class="breadcrumb-item"><a href="javascript:void(0);">Metrica</a></li>
                            <li class="breadcrumb-item"><a href="javascript:void(0);">Pages</a></li> */}
                      <li class="breadcrumb-item active">Course Mapping</li>
                    </ol>
                  </div>
                  <h4 class="page-title">Create mapping</h4>
                </div>
              </div>
            </div>
            {/* {(paymentComplete?.toLowerCase() === "full" || paymentComplete?.toLowerCase() === 'part') && */}
            <div class="row">
              <div class="col-12">
                <div class="tab-content detail-list" id="pills-tabContent">
                  <div class="tab-pane fade show active" id="general_detail">
                    <div class="row">
                      <div class="col-lg-12 col-xl-12 mx-auto">
                        <div class="card">
                          <div class="card-body">
                            <div>
                              <label className="text-danger">
                                Please provide the following
                              </label>
                            </div>
                            <br />
                            <div class="container">
                              <div class="form-group row">
                                <div class="col-md-3">
                                  <label>Level</label>
                                  <select
                                    class="form-control mb-4"
                                    value={level}
                                    onChange={(e) => setLevel(e.target.value)}
                                  >
                                    <option value="">Select level</option>
                                    <option value="100">100</option>
                                    <option value="200">200</option>
                                    <option value="300">300</option>
                                    <option value="400">400</option>
                                    <option value="500">500</option>
                                  </select>
                                </div>
                                <div class="col-md-3">
                                  <label>Affiliate</label>
                                  <select
                                    class="form-control mb-3"
                                    value={affiliate}
                                    onChange={(e) =>
                                      setAffiliate(e.target.value)
                                    }
                                  >
                                    <option value="">Select affiliate</option>
                                    <option value="AJURU UNDERGRADUATE">
                                      AJURU UNDERGRADUATE
                                    </option>
                                    <option value="AJURU POSTGRADUATE">
                                      AJURU POSTGRADUATE
                                    </option>
                                    <option value="UNIBEN UNDERGRADUATE">
                                      UNIBEN UNDERGRADUATE
                                    </option>
                                    <option value="DELSU UNDERGRADUATE">
                                      DELSU UNDERGRADUATE
                                    </option>
                                  </select>
                                  {/* <button className="btn dspg-success mr-1">
                                    Register
                                  </button> */}
                                </div>
                                <div class="col-md-3">
                                  <label>Program</label>
                                  <select
                                    class="form-control mb-3"
                                    value={program}
                                    onChange={(e) => setProgram(e.target.value)}
                                  >
                                    <option value="">Select program</option>
                                    {programList?.map((details, index) => (
                                      <option
                                        key={index}
                                        value={details.course_of_study}
                                      >
                                        {details.course_of_study}
                                      </option>
                                    ))}
                                  </select>
                                  {/* <button className="btn dspg-success mr-1">
                                    Register
                                  </button> */}
                                </div>
                                <div class="col-md-3">
                                  <label>Semester</label>
                                  <select
                                    class="form-control mb-3"
                                    value={semester}
                                    onChange={(e) =>
                                      setSemester(e.target.value)
                                    }
                                  >
                                    <option value="">Select semester</option>
                                    <option value="1">First</option>
                                    <option value="2">Second</option>
                                  </select>
                                  {/* <button className="btn dspg-success mr-1">
                                    Register
                                  </button> */}
                                </div>
                              </div>
                              {semester && level && program && affiliate ? (
                                <div className="col-lg-12">
                                  <DataTable
                                    value={courses}
                                    footer={`Total Units Selected: ${totalUnits}`}
                                    selectionMode={rowClick ? null : "checkbox"}
                                    selection={selectedCourses}
                                    onSelectionChange={handleSelectionChange}
                                    dataKey="id"
                                    tableStyle={{ minWidth: "50rem" }}
                                    loading={loading}
                                    header={header}
                                    filters={filters}
                                  >
                                    <Column
                                      selectionMode="multiple"
                                      headerStyle={{ width: "3rem" }}
                                    ></Column>
                                    <Column
                                      field="code"
                                      header="Course Code"
                                    ></Column>
                                    <Column
                                      field="title"
                                      header="Course Title"
                                    ></Column>
                                    <Column
                                      field="unit"
                                      header="Course Unit"
                                    ></Column>
                                    <Column
                                      field="semester"
                                      header="Semester"
                                    ></Column>
                                    <Column
                                      field="affliate"
                                      header="Affiliate"
                                    ></Column>
                                  </DataTable>
                                  <Paginator
                                    first={pagination}
                                    rows={1}
                                    totalRecords={totalRecords}
                                    onPageChange={onPageChange}
                                    onRowsChange={onRowsChange}
                                    template=" PrevPageLink CurrentPageReport NextPageLink"
                                  />
                                  <div className="d-flex justify-content-between mt-2">
                                    {/* <button className="btn dspg-warning" type="button" data-toggle="modal" data-target="#exampleModalCenter">Add more Courses</button> */}
                                    <button
                                      className="btn dspg-success"
                                      onClick={registerCourses}
                                    >
                                      Map Course
                                    </button>
                                  </div>
                                </div>
                              ) : (
                                ""
                              )}

                              {selectedCourses?.length ? (
                                <div className="bg-light col-lg-9">
                                  <table className="mt-3 col-lg-12">
                                    <thead className="dspg-dark">
                                      <th>Code</th>
                                      <th>Course</th>
                                      <th>Unit</th>
                                      <th>Semester</th>
                                    </thead>
                                    {selectedCourses?.map((list) => (
                                      <tbody>
                                        <td>{list.code}</td>
                                        <td>{list.title}</td>
                                        <td>{list.unit}</td>
                                        <td>{list.semester}</td>
                                      </tbody>
                                    ))}
                                    <tfoot>
                                      <tr>
                                        <td className="h5">Total Units</td>
                                        <td></td>
                                        <td className="h5">{totalUnits}</td>
                                        <td></td>
                                      </tr>
                                    </tfoot>
                                  </table>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* } */}
          </div>

          {/* {(paymentComplete?.toLowerCase() !== 'full' && paymentComplete?.toLowerCase() !== "part") &&
          <div class="alert dspg-warning" role="alert">
          Please Pay Your School Fees First
        </div>
        } */}

          <Footer />
        </div>
      )}
      <div
        class="modal fade"
        id="exampleModalCenter"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div
          class="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLongTitle">
                Search Courses
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              {/*body */}
              <div className="form-group row">
                <div className="col-md-6 position-relative">
                  <label>Search Course Code</label>
                  <input
                    className="form-control"
                    placeholder="Search..."
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                  />
                  <div
                    className="col-md-12 position-absolute bottom-50 start-50 bg-white"
                    style={{ zIndex: "100", cursor: "pointer" }}
                  >
                    {query.length >= 2 && (
                      <>
                        {filteredCourses?.map((filtered) => (
                          <h6
                            key={filtered.id}
                            onClick={() => handleCourseSelection(filtered)}
                          >
                            {filtered.code} - {filtered.title}
                          </h6>
                        ))}
                      </>
                    )}
                  </div>
                </div>
              </div>
              {/* <div class="form-group row">
            <div class="col-md-2">
              <label>Level</label>
              <select
                class="form-control"
                value={level}
                onChange={(e) =>
                  setLevel(e.target.value)
                }
              >
                <option>--Level--</option>
                <option value="100">100</option>
                <option value="200">200</option>
                <option value="300">300</option>
                <option value="400">400</option>
              </select>
            </div>
            <div class="col-md-3">
              <label>Semester</label>
              <select
                class="form-control"
                value={semester}
                onChange={(e) =>
                  setSemester(e.target.value)
                }
              >
                <option>--Select Semester--</option>
                <option value="1">FIRST</option>
                <option value="2">SECOND</option>
              </select>
            </div>
            <div class="col-md-7">
              <label>Department</label>
              <select
                class="form-control"
                value={department}
                onChange={(e) => setDepartment(e.target.value)}
              >
                <option>
                  --Select Department--
                </option>
                {departments?.map(({id, department}) => (
                  <option
                    key={id}
                    value={department}
                  >
                    {department}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="form-group row">
          <div class="col-md-12">
              <label>Academic Course</label>
              <select
                class="form-control"
                value={selectedCourses}
                onChange={handleCourseSelection}
              >
                <option>
                  --Select Academic Course--
                </option>
                {filteredCourses?.map(({course_id}) => (
                  <option
                    key={course_id.id}
                    value={JSON.stringify(course_id)}
                  >
                    {course_id.code} {course_id.title}
                  </option>
                ))}
              </select>
            </div>
          </div> */}

              {selectedCourses?.length ? (
                <div className="bg-light">
                  <p className="breadcrumb-item">Selected Courses</p>
                  <table className="col-lg-12">
                    <thead className="dspg-dark">
                      <th>Code</th>
                      <th>Title</th>
                      <th>Unit</th>
                      <th>Semester</th>
                    </thead>
                    {selectedCourses?.map((list) => (
                      <tbody>
                        <td>{list.code}</td>
                        <td>{list.title}</td>
                        <td>{list.unit}</td>
                        <td>{list.semester}</td>
                        <td onClick={() => handleCourseDelete1(list.id)}>
                          <Trash2 className="waves-effect align-self-center icon-dual-pink icon-sm" />
                        </td>
                      </tbody>
                    ))}
                    <tfoot>
                      <tr>
                        <td className="h5">Total Units</td>
                        <td></td>
                        <td className="h5">{totalUnits}</td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              ) : (
                ""
              )}
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-primary"
                data-dismiss="modal"
              >
                Done
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseMapping;
